import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeLeft16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconEdgeLeft16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.113 12.502a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 11.002a.5.5 0 1 0 1 0v-6a.5.5 0 0 0-1 0zm11.363-3.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-.75 3.5a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M4.363 2.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m3.75 9.752a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-.75-9.752a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m3.75 9.752a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-.75-9.752a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0m3 1.752a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeLeft16);
